import { render, staticRenderFns } from "./dialog-1.vue?vue&type=template&id=357247f6&scoped=true&"
import script from "./dialog-1.vue?vue&type=script&lang=ts&"
export * from "./dialog-1.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-1.vue?vue&type=style&index=0&id=357247f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357247f6",
  null
  
)

export default component.exports